import {DataFetcher} from '@aboutyou/data-fetcher';
import {RouterErrorHandler} from '@aboutyou/router';
import React from 'react';
import {MetaView, MetaViewProps} from './MetaView';
import {useGetMetaData} from './useGetMetaData';

export const Meta: React.FC<MetaViewProps> = props => {
  return (
    <DataFetcher
      request={useGetMetaData()}
      Error={RouterErrorHandler}
      View={MetaView}
      viewProps={props}
    />
  );
};
